import React, { useRef, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import Navbar from "../components/Navbar.jsx";
import Footer from "../components/common-components/Footer.jsx";
import Banner from "../components/img/Banner/ContactUs.png";
import "../styles/pages-style/ContactUs.css";
import { useForm } from "react-hook-form";
import axios from "axios";

function ContactUs() {
  const testimonialsRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const scrollToTestimonials = () => {
    if (testimonialsRef.current) {
      testimonialsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://hrishisholistichub.com/sendEmail.php",
        data, {
          headers: {
            'Content-Type': 'application/json', // Make sure you're sending JSON
          }
        }
      );
      if (response.data.success) {
        setSuccessMessage("Your message has been sent successfully!");
        setErrorMessage("");
      } else {
        setErrorMessage(
          "There was an error sending your message. Please try again."
        );
        setSuccessMessage("");
      }
    } catch (error) {
      setErrorMessage(
        "There was an error sending your message. Please try again."
      );
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Navbar scrollToTestimonials={scrollToTestimonials} />
      <Box className="ContactUs-container">
        <Box className="ContactUs-banner">
          <img src={Banner} alt="" />
          <Box className="course-banner-text">
            <Typography className="contact-title">Contact Us</Typography>
            <Box className="course-breadcrumb">
              <Typography className="contact-breadcrumb-home">Home</Typography>
              <Typography className="course-breadcrumb-current">
                {" "}
                / Contact Us
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          className="contact-us-form-container"
          sx={{
            width: "76vw",
            margin: "auto",
            marginTop: "7vh",
            padding: "30px",
            border: "1px solid #ccc",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            border: "1px solid",
            backgroundColor: "#fff",
            mb: "5vh",
          }}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box
              className="ContactUs-form-section"
              sx={{
                display: "flex",
                gap: "20px",
                marginBottom: "20px",
                justifyContent: "space-around",
              }}
            >
              <Box sx={{ width: "35vw" }} className="contact-us-page-form">
                <Typography variant="body1" sx={{ marginBottom: "5px" }}>
                  First Name
                </Typography>
                <TextField
                  fullWidth
                  label="First Name"
                  placeholder="Enter First Name"
                  variant="outlined"
                  {...register("firstName", {
                    required: "First Name is required",
                  })}
                  error={!!errors.firstName}
                  helperText={errors.firstName?.message}
                />
              </Box>
              <Box sx={{ width: "35vw" }} className="contact-us-page-form">
                <Typography variant="body1" sx={{ marginBottom: "5px" }}>
                  Last Name
                </Typography>
                <TextField
                  fullWidth
                  label="Last Name"
                  placeholder="Enter Last Name"
                  variant="outlined"
                  {...register("lastName", {
                    required: "Last Name is required",
                  })}
                  error={!!errors.lastName}
                  helperText={errors.lastName?.message}
                />
              </Box>
            </Box>

            <Box
              className="ContactUs-form-section"
              sx={{
                display: "flex",
                gap: "20px",
                marginBottom: "20px",
                justifyContent: "space-around",
              }}
            >
              <Box sx={{ width: "35vw" }} className="contact-us-page-form">
                <Typography variant="body1" sx={{ marginBottom: "5px" }}>
                  Email
                </Typography>
                <TextField
                  fullWidth
                  label="Enter Email"
                  placeholder="Enter Email"
                  variant="outlined"
                  {...register("email", {
                    required: "Email is required",
                    pattern: /^\S+@\S+\.\S+$/i,
                  })}
                  error={!!errors.email}
                  helperText={errors.email?.message}
                />
              </Box>
              <Box sx={{ width: "35vw" }} className="contact-us-page-form">
                <Typography variant="body1" sx={{ marginBottom: "5px" }}>
                  Contact Number
                </Typography>
                <TextField
                  fullWidth
                  label="Enter Contact Number"
                  placeholder="Enter Contact Number"
                  variant="outlined"
                  {...register("contact", {
                    required: "Contact number is required",
                  })}
                  error={!!errors.contact}
                  helperText={errors.contact?.message}
                />
              </Box>
            </Box>

            <Box
              sx={{
                marginBottom: "20px",
                width: "74vw",
                justifySelf: "center",
              }}
            >
              <Typography variant="body1" sx={{ marginBottom: "5px" }}>
                Enter Your Message
              </Typography>
              <TextField
                fullWidth
                placeholder="Your Message"
                variant="outlined"
                multiline
                rows={6}
                {...register("message", { required: "Message is required" })}
                error={!!errors.message}
                helperText={errors.message?.message}
              />
            </Box>

            {successMessage && (
              <Typography
                variant="body1"
                color="green"
                sx={{ marginBottom: "10px" }}
              >
                {successMessage}
              </Typography>
            )}
            {errorMessage && (
              <Typography
                variant="body1"
                color="red"
                sx={{ marginBottom: "10px" }}
              >
                {errorMessage}
              </Typography>
            )}

            <Box sx={{ textAlign: "right" }}>
              <Button
                className="ContactUs-Form-Btn"
                variant="contained"
                sx={{
                  width: "10vw",
                  mr: "1vw",
                  backgroundColor: "#844CEF",
                  padding: "10px 30px",
                  borderRadius: "20px",
                  textTransform: "none",
                  fontSize: "16px",
                  "&:hover": { backgroundColor: "#844CEF" },
                }}
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={24} sx={{ color: "#fff" }} />
                ) : (
                  "Submit"
                )}
              </Button>
            </Box>
          </form>
        </Box>

        <Footer />
      </Box>
    </Box>
  );
}

export default ContactUs;
